import { ActiveOrganizationAvatar } from "@components/avatar/ActiveOrganizationAvatar";
import { useActiveWorkspace } from "@hooks/useActiveWorkspace";
import { useIdCopy } from "@hooks/useIdCopy";
import { DefaultNavigationDropdownBody } from "../DefaultNavigationDropdownBody";
import { SideNavMenuPicker } from "./SideNavMenuPicker";

/** The workspace switcher: today's menu behind the side nav's trigger. */
export const SideNavPicker = () => {
    const activeWorkspace = useActiveWorkspace();
    const { getCopyProps } = useIdCopy({ label: "Workspace" });
    const workspaceName = activeWorkspace?.name ?? "";

    return (
        <SideNavMenuPicker
            avatar={<ActiveOrganizationAvatar size="sm" aria-hidden />}
            label={
                <span {...getCopyProps(activeWorkspace?.id)}>
                    {workspaceName}
                </span>
            }
        >
            <DefaultNavigationDropdownBody />
        </SideNavMenuPicker>
    );
};
